import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import Reveal from '../components/common/Reveal';
import { SectionHeader, Card, Tag, Pill, BtnPrimary } from '../components/ui';
import { CATEGORIES } from '../utils/constants';

export default function ArticlesPage() {
  const [articles, setArticles] = useState([]);
  const [filter, setFilter] = useState('All');

  useEffect(() => { api.get('/articles', { params: { category: filter } }).then(r => setArticles(r.data)).catch(() => {}); }, [filter]);

  return (
    <div>
      <div style={{ padding: '120px 40px 40px', textAlign: 'center', background: 'linear-gradient(160deg,var(--cream),var(--soft-orange))' }}>
        <SectionHeader title="Articles &" accent="Writings" sub={<>Read community articles or <Link to="/submit-article" style={{ color: 'var(--saffron)', fontWeight: 600 }}>submit your own</Link></>} />
      </div>
      <section style={{ padding: '40px 40px 80px', maxWidth: 800, margin: '0 auto' }}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 32 }}>
          <Pill active={filter === 'All'} onClick={() => setFilter('All')}>All</Pill>
          {CATEGORIES.map(c => <Pill key={c} active={filter === c} onClick={() => setFilter(c)}>{c}</Pill>)}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {articles.map((a, i) => (
            <Reveal key={a.id} delay={i * .07}>
              <Link to={`/articles/${a.id}`}>
                <Card style={{ padding: 28, display: 'flex', flexDirection: 'column', gap: 12, borderLeft: `4px solid ${a.category === 'Sufism' ? 'var(--saffron)' : a.category === 'Literature' ? 'var(--brown)' : a.category === 'Art' ? 'var(--gold)' : '#228B22'}` }}>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                    <Tag type={a.category}>{a.category}</Tag>
                    <span style={{ fontSize: 12, color: '#999' }}>{a.published_at ? new Date(a.published_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : ''}</span>
                    <span style={{ fontSize: 12, color: '#999' }}>{a.read_time}</span>
                  </div>
                  <h3 className="serif" style={{ fontSize: '1.35rem' }}>{a.title}</h3>
                  <p style={{ fontSize: 14, color: 'var(--brown)', fontWeight: 300, lineHeight: 1.7 }}>{a.excerpt}</p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--saffron-dark)', fontWeight: 500 }}>
                    <span>{a.author_name}</span>
                    <span style={{ marginLeft: 'auto', fontSize: 12, color: '#999' }}>Read more →</span>
                  </div>
                </Card>
              </Link>
            </Reveal>
          ))}
          {!articles.length && <div style={{ textAlign: 'center', padding: 60, color: 'var(--brown)' }}><p style={{ fontSize: 48, marginBottom: 16 }}>📝</p><p>No articles found.</p><BtnPrimary onClick={() => window.location.href = '/submit-article'} style={{ marginTop: 16 }}>Be the first →</BtnPrimary></div>}
        </div>
      </section>
    </div>
  );
}
